module.exports = __webpack_public_path__ + "static/media/icon--two-people-highfiving.01bee0f4.png";